import wordmark from "@/assets/bb-wordmark.webp";
import wordmarkWhite from "@/assets/bb-wordmark-white.webp";
import iconTile from "@/assets/bb-icon-tile.webp";

const RATIO = 988 / 241;

// BusinessBook wordmark; `light` = white version for dark backgrounds, `compact` = square icon tile.
export function BrandMark({ size = 36, light = false, compact = false, sub }) {
  if (compact) return <img data-testid="brand-mark" src={iconTile} alt="BusinessBook" width={size} height={size} decoding="async" style={{ width: size, height: size }} className="rounded-lg shadow-sm" />;
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <img src={light ? wordmarkWhite : wordmark} alt="BusinessBook by Largish" width={Math.round(size * RATIO)} height={size} decoding="async" fetchpriority="high" style={{ height: size, width: Math.round(size * RATIO) }} className="shrink-0 max-w-none" />
      {sub && <span className={`text-xs font-semibold uppercase tracking-wider pl-3 border-l ${light ? "text-teal-200 border-white/20" : "text-slate-600 border-slate-200"}`}>{sub}</span>}
    </div>
  );
}
